import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { PessoaJuridicaFormComponent } from './pessoa-juridica-form/pessoa-juridica-form.component';
import { PessoaJuridicaApiService } from "./shared/pessoa-juridica-api.service";
import { PessoaJuridicaService } from "./shared/pessoa-juridica.service";

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    PessoaJuridicaApiService,
    PessoaJuridicaService
  ],
  declarations: [
    PessoaJuridicaFormComponent
  ],
  exports: [
    PessoaJuridicaFormComponent
  ]
})
export class PessoaJuridicaModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoa-juridica/pessoa-juridica.module.ts
 **/